import { SanitisedWebStory } from './types'

export const sanitiseArrayForAmpPlayer = (
    stories: any[],
): Array<SanitisedWebStory> => {
    const sanitiseArray = stories.map((story) => {
        return {
            title: story.title,
            href: story.url,
            posterImage: story.media.poster.portrait,
            tags: story.tags.LABEL,
        }
    })
    return sanitiseArray
}
